/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules

import 'bootstrap';
import 'flickity';

global.jQuery = require('jquery');
var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

// autocomplete
require('./utils/jquery.autocomplete.js');

import App from './modules/app.js';
import Autocomplete from './partials/autocomplete.js';
import Menu from './partials/menu.js';
import Modal from './partials/modal.js';
import LoadMorePagination from './partials/load-more-pagination.js';
import LanguageSwitcher from './partials/language-switcher.js';
import FlickityCustom from './partials/flickity.js';
import Breadcrumb from './partials/breadcrumb.js';
import Download from './partials/download.js';

const app = new App();
const autocomplete = new Autocomplete();
const menu = new Menu();
const modal = new Modal();
const loadmorepagination = new LoadMorePagination();
const languageswitcher = new LanguageSwitcher();
const flickity = new FlickityCustom();
const breadcrumb = new Breadcrumb();
const download = new Download();


/**
 * Youtube
 */

$( '.bd-youtube-modal-xl' ).on( 'hide.bs.modal', function( e ) {
	$( 'iframe' ).attr( 'src', $( 'iframe' ).attr( 'src' ) );
});

/* 
	Get correct width on gutenbergs built in columns block
*/

Array.from(document.querySelectorAll(".container-md.column")).forEach(container => {
	Array.from(container.querySelectorAll(".wp-block-column")).forEach(el => {	
			if(el.getAttribute("style") && el.getAttribute("style").includes("flex-basis")){
				container.setAttribute("style", el.getAttribute("style"));
			}
		});
});


$(document).ready(function () {
    if ($("iframe").length) {
        if ($("iframe").hasClass("cookieconsent-optin-marketing")) {
            var cookiebotText = '<div class="cookieconsent-optout-marketing"><a href="javascript:Cookiebot.renew()" style="color: #e70029; text-decoration: underline; font-weight: 600;">Please accept marketing-cookies to watch this video. </a></div>';
            $(cookiebotText).insertBefore('.cookieconsent-optin-marketing');
        }
    }
});
